function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 24.5a7 7 0 100-14 7 7 0 000 14zm0-2a5 5 0 100-10 5 5 0 000 10z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 9a2 2 0 012-2h5.5l1.914-1.914a2 2 0 011.414-.586h8.344a2 2 0 011.414.586L23.5 7H29a2 2 0 012 2v18a2 2 0 01-2 2H3a2 2 0 01-2-2V9zm11.414-2.5a1 1 0 00-.707.293L9.5 9H4a1 1 0 00-1 1v16a1 1 0 001 1h24a1 1 0 001-1V10a1 1 0 00-1-1h-5.5l-2.207-2.207a1 1 0 00-.707-.293h-7.172z",
  fill: "currentColor"
})));